import React, { useContext } from "react";
import "./Report.css";
import { useLocation } from "react-router-dom";
import { AuthContext } from "./../../ContextApi/ContextApi";
import Navbar from "../../shared/Navbar";
import { RawBTPrinter } from "../../../utils/rawbtPrinter";

const PrintReport = () => {
  const { state } = useLocation();
  const data = state?.data || [];

  const { firstName, lastName, userMobile, bank } = useContext(AuthContext);

  const padLine = (label, value, lineWidth = 32) => {
    let spaces = lineWidth - label.length - value.length;
    if (spaces < 1) spaces = 1;
    return label + " ".repeat(spaces) + value;
  };

  const formatAmount = (v) => (v ? parseFloat(v).toFixed(2) : "0.00");

  const handlePrintReceipt = () => {
    let commands = "";

    data.forEach((entry) => {
      commands += String.fromCharCode(27) + "@";
      commands += String.fromCharCode(27) + "a" + String.fromCharCode(1);
      commands += String.fromCharCode(27) + "!" + String.fromCharCode(32);
      commands += "*** RECEIPT ***\n";

      commands += String.fromCharCode(27) + "!" + String.fromCharCode(0);

      commands += `${bank || ""}\n\n`;

      commands += String.fromCharCode(27) + "a" + String.fromCharCode(0);

      commands += `Rec No: ${entry.id}  Date: ${entry.Today}\n`;
      commands += `NAME : ${entry.Name}\n`;
      commands += `ACC NO : ${entry.AccountNo}\n`;
      commands += `ACC TYPE: ${entry.AccountType}\n\n`;

      commands += padLine(
        "OPENING BALANCE",
        formatAmount(entry.PreviousBalance)
      ) + "\n";

      commands += padLine("RECEIVED", formatAmount(entry.Recieved)) + "\n";
      commands += padLine("BALANCE", formatAmount(entry.PresentBalance)) + "\n\n";

      commands += "THANK YOU\n";
      commands += `${firstName} ${lastName}\n`;
      commands += `${userMobile}\n\n\n`;
    });

    RawBTPrinter.printEscPos(commands);
  };

  return (
    <div>
      <Navbar />

      <div className="ReportContainer">

        {/* ---- 2 Column Header ---- */}
        <div className="ReportHeaderRow">
          <div className="ReportHeaderCell">AccountNo</div>
          <div className="ReportHeaderCell">Recieved</div>
        </div>

        {/* ---- 2 Column Rows ---- */}
        {data.map((item) => (
          <div key={item.id} className="ReportDataRow">
            <div className="ReportCell">{item.AccountNo}</div>
            <div className="ReportCell">{item.Recieved}</div>
          </div>
        ))}

        <button className="PrintReceiptBtn" onClick={handlePrintReceipt}>
          🖨 Print Receipts
        </button>
      </div>
    </div>
  );
};

export default PrintReport;
